import type { HomeSettings } from "building-types/settings/homeSettings";
import type { Settings } from "building-types/settings/settings";
import type { Paths } from "common/utils/dotNotationTypes";
import { getValue } from "common/utils/dotNotationUtils";
import type { SettingsCriterion } from "./provenanceTypes";

export function getSettingsCriterion(homeSettings: HomeSettings, path: Paths<HomeSettings>): SettingsCriterion | null {
  const { result, success } = getValue<HomeSettings, any>(homeSettings, path);
  if (!success) {
    return null;
  }

  const pathComponents = path.split(".");

  /**
   * The first component of the path is the SettingsType by convention.
   */
  const settingsTypePath = pathComponents[0] as Paths<HomeSettings>;
  const settingResult = getValue<HomeSettings, Settings>(
    homeSettings,
    settingsTypePath as Paths<HomeSettings, Settings>,
  );

  if (!settingResult.success) {
    return null;
  }

  const settingsType = settingResult?.result?.type;
  if (!settingsType) {
    return null;
  }

  return {
    type: "SETTINGS_CRITERION",
    settingsType,
    path,
    value: result.toString(),
  };
}

export function makeSettingsCriteriaHash(provenanceConditions: SettingsCriterion[]): string {
  if (!provenanceConditions?.length) {
    return "";
  }

  const list = provenanceConditions.map((condition) => condition.value);
  return list.join(".");
}
